import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from './supabaseClient.ts';
import { useTutorSession } from './context/TutorSessionContext.tsx';

/**
 * Renders `element` if the user is signed-in.
 * Otherwise drops them on the public practice page.
 */
const ProtectedRoute: React.FC<{ element: React.ReactElement }> = ({ element }) => {
  const { isTutorSession } = useTutorSession();
  const [loading, setLoading]   = useState(true);
  const [isAuthed, setIsAuthed] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setIsAuthed(!!session);
      setLoading(false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_e, session) => setIsAuthed(!!session)
    );
    return () => subscription.unsubscribe();
  }, []);

  if (loading) return null;            // or splash
  return isAuthed || isTutorSession ? element : <Navigate to="/practice" replace />;
};

export default ProtectedRoute;
